import { render, staticRenderFns } from "./UpdateCases.vue?vue&type=template&id=4c51ca77&scoped=true"
import script from "./UpdateCases.vue?vue&type=script&lang=js"
export * from "./UpdateCases.vue?vue&type=script&lang=js"
import style0 from "./UpdateCases.vue?vue&type=style&index=0&id=4c51ca77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c51ca77",
  null
  
)

export default component.exports